import { ReactElement } from 'react'

import Icon from '@ant-design/icons'

import { IconProps } from '../localTypes'

import AutomationIconSvg from './AutomationIconSvg'

const AutomationIcon = (props: IconProps): ReactElement => (
    <Icon component={AutomationIconSvg} {...props} />
)

export default AutomationIcon
